







import Vue from 'vue';
import { Component } from 'vue-property-decorator';
import {
  TLeadsDetailForm,
  TProjectPage,
  TProjectSearch,
  TCourse_Page,
  TCourse_Search
} from '@/types/views/school';
import {
  getLeads,
  getProjectPage,
  getCoursePageByTeacherId,
  getCoursePage
} from '@/api/school';
@Component({
  components: {
    Info: () => import('./components/info.vue'),
    Project: () => import('./components/project-list.vue'),
    Course: () => import('./components/course-list.vue')
  }
})
export default class Detail extends Vue {
  private info: TLeadsDetailForm = {
    id: 0,
    phone: '',
    childName: '',
    age: 0,
    sex: '',
    grade: '',
    school: '',
    name: '',
    parentName: '',
    intention: '',
    nextComm: '',
    startTime: '',
    dataStatus: '',
    content: '',
    userName: ''
  };
  private projectPage: any;
  private projectOptions: any;
  private coursePage: any;
  private courseOptions: TCourse_Search = {
    pageSize: 20,
    currentPage: 1,
    phone: ''
  };
  private activated() {
    let phone = this.$route.query.phone;
    Object.assign(this.projectOptions, { phone });
    Object.assign(this.courseOptions, { phone });

    this.getInfo();
    this.getProjectPage();
    this.getCoursePage();
  }
  private handleProjectOptions(opts: TProjectSearch) {
    this.projectOptions = { ...this.projectOptions, ...opts };
  }
  private handleCourseOptions(opts: TCourse_Search) {
    this.courseOptions = { ...this.courseOptions, ...opts };
  }
  private async getInfo() {
    try {
      const id = this.$route.params.id;
      let res: any = await getLeads({ id });
      this.info = res;
    } catch (e) {
      this.$message.error(e.message);
    }
  }
  private async getProjectPage() {
    try {
      this.projectPage = await getProjectPage(this.projectOptions);
    } catch (e) {
      this.$message.error(e.message);
    }
  }
  private async getCoursePage() {
    try {
      this.coursePage = await getCoursePage(this.courseOptions);
    } catch (e) {
      this.$message.error(e.message);
    }
  }
}
